import api from './axios';
import { Unit } from '../types';

export const unitsApi = {
  getAll: () =>
    api.get<Unit[]>('/units'),

  getById: (id: number) =>
    api.get<Unit>(`/units/${id}`),

  create: (data: Partial<Unit>) =>
    api.post<Unit>('/units', data),

  update: (id: number, data: Partial<Unit>) =>
    api.put<Unit>(`/units/${id}`, data),

  delete: (id: number) =>
    api.delete(`/units/${id}`),
};
